import { useMediaQuery } from '@mui/material';

/**
 * Touch-first compact layouts (phones; small tablets).
 * Landscape mode uses orientation, not breakpoint width — phone landscape often stays below `md`.
 */
export function useMobileLayout() {
  const isCoarsePointer = useMediaQuery('(hover: none) and (pointer: coarse)');
  const isCompactWidth = useMediaQuery('(max-width: 1024px)');
  const isPortraitOrientation = useMediaQuery('(orientation: portrait)');
  const isLandscapeOrientation = useMediaQuery('(orientation: landscape)');

  const isMobile = isCoarsePointer && isCompactWidth;
  const isLandscapeMobile = isMobile && isLandscapeOrientation;
  const isPortraitMobile = isMobile && isPortraitOrientation;

  return { isMobile, isPortraitMobile, isLandscapeMobile };
}
